var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 165,
    viewBox: "0 0 201 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10C0.5 4.47715 4.97715 0 10.5 0H47.6727C51.2741 0 54.5974 1.93655 56.3729 5.06988L59.1271 9.93013C60.9026 13.0635 64.2259 15 67.8273 15H190.5C196.023 15 200.5 19.4772 200.5 25V155C200.5 160.523 196.023 165 190.5 165H10.5C4.97716 165 0.5 160.523 0.5 155V10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.a7de7d937a670d0681286f7fc4a6e61c.svg";
export { ForwardRef as ReactComponent };